// Dialog session currently being played, attached to every App Insights item as the
// `SessionId` custom dimension (same name the backend uses) so a conversation's frontend
// and backend telemetry can be queried together.
let currentSessionId: string | null = null;

export const setTelemetrySessionId = (sessionId: string | null | undefined) => {
  currentSessionId = sessionId || null;
};

export const getTelemetrySessionId = () => currentSessionId;

export const applyTelemetrySession = (envelope: { data?: Record<string, unknown> }) => {
  if (!currentSessionId) {
    return;
  }
  envelope.data = envelope.data || {};
  envelope.data.SessionId = currentSessionId;
};
